var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "col-12 col-lg" }, [
        _c(
          "div",
          {
            staticClass: "mb-1 font-weight-bold",
            class: { "text-transparent text-center small": !_vm.title }
          },
          [_vm._v(" " + _vm._s(_vm._f("empty")(_vm.title)) + " ")]
        ),
        _c("div", { staticClass: "rounded py-2 bg-gray-9" }),
        _c("div", { staticClass: "mt-3 d-flex align-items-center" }, [
          _c("div", [
            _c("p", {
              staticClass: "font-weight-bold mb-1 py-1",
              domProps: { innerHTML: _vm._s(_vm.name) }
            }),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.notes) } })
          ])
        ])
      ]),
      _vm._l(_vm.data.answers, function(answer, key) {
        return _c(
          "div",
          { key: answer.answerId, staticClass: "col-md-custom col-6 px-0" },
          [
            _c(
              "div",
              { staticClass: "text-center small mb-1 font-weight-bold" },
              [_vm._v(" " + _vm._s(_vm._f("empty")(answer.text)) + " ")]
            ),
            _c("div", {
              staticClass: "rounded py-2 mx-2",
              style: { backgroundColor: answer.color }
            }),
            _c(
              "div",
              {
                staticClass: "my-3 py-3 border-top border-bottom",
                class: {
                  "ml-2 border-left rounded-left": key === 0,
                  "mr-2 border-right rounded-right":
                    key === _vm.data.answers.length - 1,
                  "bg-gray-9":
                    _vm.isReadOnly || answer.answerId === _vm.checked,
                  "cursor-no-drop": _vm.isReadOnly,
                  "cursor-pointer": !_vm.isReadOnly
                },
                on: {
                  click: function($event) {
                    return _vm.onSelectAnswer(answer.answerId)
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c("b-form-radio", {
                      staticClass: "pl-4 ml-3 custom-radio",
                      attrs: {
                        checked: _vm.checked,
                        disabled: _vm.isReadOnly,
                        size: "lg",
                        value: answer.answerId
                      },
                      on: { input: _vm.onSelectAnswer }
                    }),
                    _vm._v(" " + _vm._s(answer.value) + " ")
                  ],
                  1
                )
              ]
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }